import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import IntlComponent from 'axway-react-intl';
import cn from 'classnames';
import Icon from 'components/widgets/Icon';
import FlowGraphNodeHandle from './FlowGraphNodeHandle';

class FlowGraphStartNode extends React.Component {
	constructor(props) {
		super(props);
		IntlComponent.init(this);

		this.initConnect = this.initConnect.bind(this);
		this.startConnect = this.startConnect.bind(this);
		this.state = {
			connecting: props.connecting
		};
	}

	componentWillReceiveProps(props) {
		// Connecting is going in state as we want to
		// delay the connector but delay the edge line.
		this.state.connecting = props.connecting;
	}

	componentDidMount() {
		const { outputHandles } = this.props;
		outputHandles && outputHandles(this.getConnectionPoints());
	}

	componentDidUpdate() {
		const { outputHandles } = this.props;
		outputHandles && outputHandles(this.getConnectionPoints());
	}

	getConnectionPoints() {
		return {
			start: {
				x: this.detailEl.offsetLeft + (this.detailEl.offsetWidth / 2),
				y: this.detailEl.offsetTop + this.detailEl.offsetHeight
			}
		};
	}

	initConnect() {
		this.setState({
			connecting: {
				source: true,
				output: 'start'
			}
		});
	}

	startConnect() {
		const { connecting } = this.state;
		const { onStartConnect, onSelect, id } = this.props;
		if (connecting && connecting.source) {
			onSelect();
			this.setState({ connecting: null },
				() => onStartConnect && onStartConnect(id, connecting.output)
			);
		}
	}

	renderStart() {
		const {
			icon,
			invalid,
			onSelect,
			className
		} = this.props;

		const classes = cn('detail', className, { invalid });

		const name = this.props.name || this.intl.formatMsg('Start');

		return (
			<div
				ref={(r) => { this.detailEl = r; }}
				className={classes}
				onClick={onSelect}
				onMouseDown={(e) => (e.button === 0) && this.initConnect(e)}
				onMouseLeave={this.startConnect}
			>
				<div className="content">
					<Icon src={icon} className="node-icon" />
					<div
						className="text node-name"
						title={name}
					>
						{name}
					</div>
				</div>
				<FlowGraphNodeHandle />
			</div>
		);
	}

	render() {
		const { selected, id, className } = this.props;
		const { connecting } = this.state;
		const classes = cn(
			'node',
			'flow-graph-start-node',
			connecting,
			className,
			{
				selected,
				connecting,
				nottargetable: true,
				source: connecting && !!connecting.source
			}
		);

		const detail = this.renderStart();

		return (
			<div
				id={id}
				className={classes}
			>
				{detail}
			</div>
		);
	}
}

FlowGraphStartNode.propTypes = {
	/**
	 * This ID of the node
	 */
	id: PropTypes.string.isRequired,
	/**
	 * The name of the node.  Defaults to "Start".
	 */
	name: PropTypes.string,
	/**
	 * Boolean to indicated if this node is selected.
	 */
	selected: PropTypes.bool,
	/**
	 * Render the node in connecting mode.
	 * source: true if this is the connection source.
	 * output: the output for the connection source (if this is the source).
	 */
	connecting: PropTypes.shape({
		source: PropTypes.bool,
		output: PropTypes.string
	}),
	/**
	 * Callback when this node is selected.
	 */
	onSelect: PropTypes.func.isRequired,
	/**
	 * Callback when a connection from this node is initiated. Callback is
	 * passed the node id and an object indicating the type of selection (parameters|output)
	 * and for output the output name.
	 */
	onStartConnect: PropTypes.func,
	/**
	 * Callback that recieves the bounding rects of the output nodes.
	 */
	outputHandles: PropTypes.func,
	/**
	 *
	 */
	className: PropTypes.string,
	/**
	 *
	 */
	icon: PropTypes.string,
	/**
	 * Not directly used in this implementation, but triggers use it.
	 */
	disabled: PropTypes.bool
};

FlowGraphStartNode.defaultProps = {
	icon: 'icon-GG-request'
};

export default injectIntl(FlowGraphStartNode);
